import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import AppLoader from "../../../utils/AppLoader";
import { Button, Input, Textarea } from "../../../styles";
import CustomSelect from "../../../utils/CustomSelect";
import OrderDetails from "./OrderDetails";
import { useItemContext } from "../../../context/item_context";
import { ICON_PLUS } from "../../../utils/icons";

const ServicesItemDetails = ({ props }) => {

    const [orderItem, setOrderItem] = useState([]);

    // Item Form
    const [tableItems, setTableItems] = useState({
        item_id: "",
        qty: 1,
        price: 0,
        amount: Number(),
        item_name: "",
        description: ""
    });

    const [itemQty, setItemQty] = useState('');

    const [showDes, setshowDes] = useState(false);

    // Get all Services

    const {
        serviceLoading, allServices, getServiceData,
    } = useItemContext();

    useEffect(() => {
        getServiceData();
    }, []);

    const services = allServices?.map((({ item, id }, i) => {
        return { label: item, value: id };
    }));


    // Get Service Price and Calc Amount

    const calculateAmount = () => {
        tableItems.amount = tableItems.price * tableItems.qty;
    };


    // Get Item Price and Calc Amount
    const getServicePrice = (e) => {
        if (e == "0") {
            let itemName = "";
            setTableItems({ item_id: e, item_name: itemName });
            calculateAmount();
        } else {
            let priceIndex = allServices.findIndex(x => x.id === e);
            let itemName = allServices[priceIndex].item;
            let description = allServices[priceIndex].details;
            setTableItems({
                item_id: e,
                item_name: itemName,
                description: description,
                qty: "1",
                price: "",
                amount: ""
            });
            calculateAmount();
        }
    };
    calculateAmount();

    // Get Item Price and Calc Amount


    // Add New Button
    const addNewService = (e) => {
        e.preventDefault();

        // if (+parseFloat(itemQty).toFixed(2) > +tableItems.qty) {
        //     toast.error(`only ${ tableItems.qty } ${ tableItems.item_name }(s) is available.`);
        // } else {
        // }
        if (tableItems.price == 0 || tableItems.item_name === '') {
            toast.warn('Select an item or add a price!');
        } else {
            calculateAmount();
            setOrderItem([...orderItem, tableItems]);
            document.getElementById("itemForm").reset();
            setTableItems({
                invtid: "",
                item_id: "",
                qty: 1,
                price: 0,
                amount: Number(),
                item_name: "",
                description: ""
            });
        }
    };


    const handleChange = (e) => {
        setTableItems({ ...tableItems, [e.target.name]: e.target.value });

    };
    // Add New Button
    // Item Form


    return (
        <>
            {/* Item Details */}
            {/* Item Details */}


            <form autoComplete="off" id="itemForm">
                <div className="row">
                    <div className="col-md-4 col-lg-5">
                        <label className="mt-3 m-0"> Services:</label>

                        <CustomSelect
                            options={services}
                            isSearchable={true}
                            onChange={e => getServicePrice(e.value)}
                            placeholder='Select Services'
                            id='service'
                        />
                        <div className="d-flex ">
                            <input
                                name="des"
                                type="checkbox"
                                id="des"
                                value="des"
                                onClick={(e) => setshowDes(!showDes)}
                                checked={showDes}
                            />
                            <label className="ml-2 m-0 small" htmlFor="des"> Description </label>
                        </div>

                        <p
                            className="red-text pointer small"
                        // onClick={(e) => workModal()}
                        >
                            Services not found? Click here to add new services
                        </p>
                        {showDes &&
                            <Textarea
                                type="text"
                                name="description"
                                rows="3"
                                required
                                disabled
                                value={tableItems.description}
                            ></Textarea>
                        }

                    </div>

                    <div className="col-md-3 col-lg-2">
                        <label className="mt-3 m-0">Qty: </label>

                        <div className="d-flex align-items-center br-sm ">
                            <Input
                                className=" pb-3 px-0 mb-2 text-center  d-flex align-items-center"
                                name="qty"
                                type="number"
                                placeholder="qty"
                                onChange={handleChange}
                                value={tableItems.qty}
                                required
                                disabled
                            />
                        </div>
                    </div>
                    <div className="col">
                        <label className="mt-3 m-0">Price:</label>

                        <Input
                            name="price"
                            type="number"
                            className="pl-4"
                            placeholder="price"
                            onChange={handleChange}
                            value={tableItems.price}
                            required
                        />
                    </div>
                    <div className="col ">
                        <label className="mt-3 m-0">Amount:</label>

                        <Input
                            name="amount"
                            type="number"
                            className=" pl-4"
                            placeholder="amount"
                            onChange={handleChange}
                            value={tableItems.amount}
                            required
                            disabled
                        />
                        <span className="withSign">₦</span>
                    </div>
                </div>

            </form>
            <div className="text-center mx-auto mb-4">
                <Button
                    pry
                    type="submit"
                    className="btn w-md-100"
                    onClick={e => addNewService(e)}
                >
                    {ICON_PLUS}   Add New
                </Button>
            </div>

            {/* Item Details */}
            {/* Item Details */}


            {/* Order Details */}
            {/* Order Details */}

            <OrderDetails
                orderItem={orderItem}
                setOrderItem={setOrderItem}
                props={props}
                api={'addSalesService'}
            />

            {/* Order Details */}
            {/* Order Details */}

            {serviceLoading ? <AppLoader /> : <></>}


            {/* Add Services Modal */}
            {/* <AddIntentoryFromSales
                show={showremove}
                onHide={handleCloseremove}
                animation={false}
                getInvent={e => getInvent()}
            /> */}
            {/* Add Services Modal */}



        </>
    );
};

export default ServicesItemDetails;

